import { Typography, Box } from '@material-ui/core';
import React, { useMemo } from 'react';
import moment from 'moment';
import { ROLES_FOR_COMMENT } from '../../hooks/useRequestCommentCommon';
import useAuth from '../../../../hooks/useAuth';

export const EDIT_INFO_TYPE = {
    REQUEST: 'REQUEST',
    COMMENT: 'COMMENT',
};

export const EditInfo = ({ type, updatedDate = '', created_date = '', updatedBy, time = '' }) => {
    const auth = useAuth();
    const { role } = auth.user || {};

    // Display the commenter name and updated date
    const editInfoDisplay = useMemo(() => {
        if (!updatedDate || !moment(updatedDate).isValid()) return '';

        const baseFormatStyle = 'YYYY/MM/DD h:mm A';
        if (type === EDIT_INFO_TYPE.REQUEST) {
            return moment.utc(updatedDate).local().format(baseFormatStyle);
        }

        const timeStamp = moment.utc(updatedDate).local().format(baseFormatStyle)

        if (!ROLES_FOR_COMMENT.includes(role)) return timeStamp;

        const isEdited = created_date && updatedDate !== created_date;
        let updatedByDisplay = `${updatedBy ?? ''}${isEdited ? ' (edited)' : ''}`;

        return (
            <>
                {timeStamp}<br />{updatedByDisplay}
            </>
        );
    }, [updatedDate, role, type, created_date]);

    // Display countdown for request comment
    const showCountdown = useMemo(() => {
        return type === EDIT_INFO_TYPE.REQUEST && time.length > 0 && updatedDate
    }, [updatedDate, type, time]);

return (
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', color: 'gray' }}>
            <Typography style={{ fontSize: '11px', textAlign: 'end' }}>
                {editInfoDisplay}
            </Typography>
            {showCountdown && (
                <Typography style={{ fontSize: '11px', textAlign: 'end' }}>
                    {time} mins left
                </Typography>
            )}
        </Box>
    );
};export default EditInfo;
